<div class="centered-content">
  <div class="card mb-4">
    <div class="card-header">
      <img src="assets/img/logo-artheau-transparent.png" height="40" /> <em>SIMPLY</em>fly
    </div>
    <div class="card-body">
      <h4 [innerText]="'AUTH.SET_PASSWORD_TITLE' | translate"></h4>

      <form (ngSubmit)="submitForm()" [formGroup]="form" (keydown.enter)="submitForm()">
        @if (!currentEmail) {
          <div class="form-group">
            <label class="form-label" [innerText]="'EMAIL' | translate"></label>
            <input
              tabindex="1"
              type="email"
              class="form-control"
              formControlName="email"
              placeholder="email@email.com"
              [class.is-invalid]="email.invalid && (email.dirty || email.touched)"
              />
            @if (email.dirty && email.errors) {
              <div class="invalid-tooltip">
                @if (email.errors && email.errors['required']) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
                @if (email.errors && email.errors['email']) {
                  <div [innerText]="'FORM_VALIDATIONS.VALID_EMAIL' | translate"></div>
                }
              </div>
            }
          </div>
        }

        <div class="form-group">
          <label class="form-label" [innerText]="'AUTH.PASSWORD' | translate"></label>
          <div class="input-group">
            <input
              tabindex="2"
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              [placeholder]="'AUTH.PASSWORD' | translate"
              formControlName="password"
                            [class.is-invalid]="
                                password.invalid && (password.dirty || password.touched)
                            "
              />
            <button class="btn" type="button" (click)="toggleType()" tabindex="3">
              @if (!showPassword) {
                <fa-icon [icon]="faEye"></fa-icon>
              }
              @if (showPassword) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
              }
            </button>
            @if (password.dirty && password.errors) {
              <div class="invalid-tooltip">
                @if (password.errors && password.errors['required']) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
                @if (password.errors && password.errors['minlength']) {
                  <div [innerText]="('FORM_VALIDATIONS.MIN_LENGTH' | translate:{ requiredLength: password.errors['minlength']['requiredLength'] })"></div>
                }
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label for="confirmPassword" [innerText]="'AUTH.CONFIRM_PASSWORD' | translate"></label>
          <div class="input-group">
            <input
              formControlName="confirmPassword"
              id="confirmPassword"
              class="form-control"
              [type]="showPassword ? 'text' : 'password'"
              [placeholder]="'AUTH.CONFIRM_PASSWORD' | translate"
              required
                            [class.is-invalid]="
                                confirmPassword.invalid &&
                                (confirmPassword.dirty || confirmPassword.touched)
                            "
              />
            <button class="btn" type="button" (click)="toggleType()" tabindex="3">
              @if (!showPassword) {
                <fa-icon [icon]="faEye"></fa-icon>
              }
              @if (showPassword) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
              }
            </button>
            @if (
              confirmPassword.invalid &&
              (confirmPassword.dirty || confirmPassword.touched) &&
              confirmPassword.errors.required
              ) {
              <div
                class="invalid-tooltip"
                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
              ></div>
            }
            @if (
              confirmPassword.invalid &&
              (confirmPassword.dirty || confirmPassword.touched) &&
              confirmPassword.errors['isMatching'] === false
              ) {
              <div
                class="invalid-tooltip"
              [innerText]="'PASSWORDS_MUST_MATCH' | translate"></div>
            }
          </div>
        </div>

        <button
          class="w-100 btn btn-lg btn-primary mt-2"
          type="submit"
          [disabled]="form.disabled || !form.valid"
          (click)="submitForm()"
          tabindex="5"
          [innerText]="'GENERAL.SAVE' | translate"
        ></button>
      </form>
    </div>
  </div>
</div>
